<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="downloader-content">
    <h1>{{'DA_DOWNLOAD_D3E' | translate}}</h1>
    <p>{{'DOWNLOAD_CIGENT_SUB_TITLE' | translate}}</p>
    <button id="download-cigent-button" mat-flat-button color="primary" [disabled]="isDownloadDisabled" (click)="onDownloadClick()">
        <span class="mdi mdi-microsoft-windows icon" aria-hidden="true"></span><span>{{'DA_DOWNLOAD_D3E' | translate}}</span>
    </button>
    <div>
        <label>{{'DOWNLOAD_CIGENT_WINDOWS_NOTICE' | translate}}</label>
    </div>
    <div class="login-link">
        <a *ngIf="!inIFrame; else newWindow;" id="login-link" aria-label="Sign in to manage your account." routerLink="/login">
            {{'DOWNLOAD_CIGENT_LOGIN_LINK' | translate}}
        </a>
        <ng-template #newWindow>
            <a id="login-link" href="{{loginUrl}}" aria-label="Sign in to manage your account." target="_blank" rel="noopener noreferrer">
                {{'DOWNLOAD_CIGENT_LOGIN_LINK' | translate}}
            </a>
        </ng-template>
    </div>
    <div class="contact-us">
        <span>{{'DOWNLOAD_CIGENT_ADD_LICENSES' | translate}}&nbsp;</span>
      <a class="contact-us-link" href="https://www.cigent.com/contact" target="_blank" rel="noopener noreferrer">{{'SUB_CONTACT' | translate}}</a>
    </div>
    <span class="terms-of-use">
      Cigent's
      <a href="https://www.cigent.com/terms" target="_blank" rel="noopener noreferrer">{{'DIV_TOUB' | translate}}</a>
        <span>&nbsp;{{'SUB_AND' | translate}}&nbsp;</span>
      <a href="https://www.cigent.com/policies" target="_blank" rel="noopener noreferrer">{{'DIV_TOUD' | translate}}</a>.
    </span>
</div>
